import { animated, useSpring } from '@react-spring/web';
import React, { useEffect, useRef, useState } from 'react';
import { useWindowSize } from 'usehooks-ts';
import { useGlobalState } from '../../../state/GlobalStateProvider';
import { capitalizeFirstLetter } from '../../../utils';
import { Flexbox, FlexboxColumn } from '../../action/Flexbox';
import Grid from '../../action/Grid';
import Logo from '../../Logo/Logo';
import ThemedText from '../../theme/ThemedText';
import ThemeLogo from '../../theme/ThemeLogo';
import './ProjectSelector.scss';

function EachProtocol({ protocolData, handleClick, selected }) {
  return (
    <FlexboxColumn
      gap='0.5rem'
      fw
      alignItems='flex-start'
      className={`expandable_category_wrapper_each ${protocolData?.protocol === selected?.value && 'expandable_category_wrapper_selected'} ${protocolData?.disabled && `expandable_category_wrapper_disabled`}`}
      onClick={() => handleClick(protocolData)}
    >
      <Flexbox gap='0.25rem'>
        <Logo width={'1rem'} height={'1rem'} borderRadius='50%' src={protocolData?.logo} />
        <ThemedText.H6>{protocolData?.name}</ThemedText.H6>
      </Flexbox>
      {/* <Flexbox gap='0.5rem'>
        <Flexbox gap='0.15rem'>
          <ThemedText.H6 color='color_xlight' weight='medium'>
            {formatDecimals(protocolData?.rating) || 0}
          </ThemedText.H6>
          <svg width='10' height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M5.00709 0L6.45206 3.42822L10 3.82761L7.34358 6.33107L8.07843 10L4.99187 8.11886L1.89813 9.9872L2.64686 6.32109L0 3.80675L3.54922 3.42214L5.00709 0Z'
              fill='#7284FF'
            />
          </svg>
          
        </Flexbox>
        <ThemedText.H6 color='color_xlight'>({protocolData?.reviewCount || 0})</ThemedText.H6>
      </Flexbox> */}
    </FlexboxColumn>
  );
}

function ExpandableCategory({ categoryName, items, handleClick, selected }) {
  const [expanded, setExpanded] = useState(false);
  const contentRef = useRef(null);
  const [contentHeight, setContentHeight] = useState(0);
  const [{ protocolMapping }] = useGlobalState();
  const { width } = useWindowSize();
  const defaultVisibleCount = width > 600 ? 4 : 2;

  const visibleItems = expanded ? items : items.slice(0, defaultVisibleCount);

  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(contentRef.current.scrollHeight);
    }
  }, [expanded, items, defaultVisibleCount]);

  const animationProps = useSpring({
    height: contentHeight,
    opacity: 1,
    config: { tension: 250, friction: 30 },
  });

  return (
    <FlexboxColumn fw className={`expandable_category_wrapper`}>
      <Flexbox fw justifyContent='space-between'>
        <ThemedText.H5>
          {capitalizeFirstLetter(categoryName)} ({items?.length || 0})
        </ThemedText.H5>
        {items.length > defaultVisibleCount ? <ThemeLogo className={'pointer'} onClick={() => setExpanded(prev => !prev)} icon={'dropdownDownArrow'} /> : <div></div>}
      </Flexbox>

      {/* Animated container wrapping the content */}
      <animated.div style={{ ...animationProps, overflow: 'hidden', width: '100%' }}>
        <Grid gap='2rem' columns={width > 600 ? 4 : 2} responsive={false} ref={contentRef}>
          {visibleItems.map((item, idx) => (
            <EachProtocol protocolData={item} key={idx} handleClick={handleClick} selected={selected} />
          ))}
        </Grid>
      </animated.div>
    </FlexboxColumn>
  );
}

export default ExpandableCategory;
